export const VIRTUAL_TOUR_TABS = {
  INTERIOR: 'interior',
  EXTERIOR: 'exterior',
}

export const CAROUSEL_CONFIG = {
  controls: false,
  nav: true,
  mouseDrag: false,
  touch: false, // prevents changing slides on drag
  autoplay: false,
  loop: false,
}

export const VIRTUAL_TOUR_EVENT = {
  START_INTERIOR: 'virtual-tour-interior',
  START_EXTERIOR: 'virtual-tour-exterior',
  HOTSPOT: 'virtual-tour-hotspot',
}
